(function () {
    'use strict';

    angular
        .module('app')
        .config(configRoutes);

    configRoutes.$inject = ['$stateProvider', '$urlServiceProvider', 'scoringResolver', 'scoreHistoryResolver', 'golferScorePostingResolver', 'accountSettingsResolver', 'courseHandicapResolver', 'testResolver'];
    function configRoutes($stateProvider, $urlServiceProvider, scoringResolver, scoreHistoryResolver, golferScorePostingResolver, accountSettingsResolver, courseHandicapResolver, testResolver) {
        $urlServiceProvider.config.caseInsensitive(true);
        $urlServiceProvider.config.defaultSquashPolicy(true);

        $stateProvider.state('home', {
            url: '/',
            component: 'sc3Home',
            redirectTo: {
                state: 'home.at-a-glance'
            },
        });

        $stateProvider.state('login', {
            url: '/login?{redirectURL:string}',
            component: 'sc3Login',
            params: {
                redirectTo: null,
                redirectParams: null,
                logout: false,
                redirectURL : null
            },
            data: {
                allowAnonymous: true
            }
        });

        $stateProvider.state('logout', {
            url: '/logout',
            redirectTo: {
                state: 'login',
                params: { logout: true }
            },
            data: {
                allowAnonymous: true
            }
        });


        $stateProvider.state('scoring', {
            url: '/scoring/:individualId',
            component: 'sc3Scoring',
            resolve: scoringResolver,
            params: {
                individualId: { type: "int", value: null }
            },
           
            redirectTo: 'scoring.history'
        });

        $stateProvider.state('score-history', {
            url: '/score-history/:individualId',
            component: 'sc3ScoreHistory',
            resolve: scoreHistoryResolver,
            params: {
                individualId: null
            }
        });

        $stateProvider.state('post-score', {
            url: '/post-score/:scoreId?{teeTimeId:int}{courseId:int}{playDate:string}',
            component: 'sc3GolferScorePosting',
            resolve: golferScorePostingResolver,
            params: {
                scoreId: null,
                teeTimeId: null,
                courseId: null,
                playDate: null
            }
        });

        $stateProvider.state('member-benefits', {
            url: '/member-benefits',            
            redirectTo: 'member-benefits.default'
        });

        $stateProvider.state('referral', {
            url: '/referral',
            redirectTo: 'referral.default'
        });

        $stateProvider.state('account-settings', {
            url: '/account-settings?{new:bool}',
            params: { 'new': false },
            redirectTo: 'account-settings.default'
        });

        $stateProvider.state('course-handicap', {
            url: '/course-handicap/:individualId?facilityId',
            component: 'sc3CourseHandicap',
            resolve: courseHandicapResolver,
            params: {
                individualId: null
            }
        });

        $stateProvider.state('test', {
            url: '/test',
            component: 'sc3Test',
            resolve: testResolver,
            data: {
                allowAnonymous: true
            }
        });
    }
})();